import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit
} from '@angular/core';
import * as moment from 'moment';
import { PowerAndIrradianceTrendParametersModel } from '../../../models/solar-configuration.model';
import { PlantServiceService } from '../../../services/dashboard/solar/plant-service.service';
@Component({
  selector: 'app-plant-performance',
  templateUrl: './plant-performance.component.html',
  styleUrls: ['./plant-performance.component.scss']
})
export class PlantPerformanceComponent
  implements OnInit, AfterViewInit, OnDestroy, OnChanges
{
  // eslint-disable-next-line @angular-eslint/no-input-rename
  @Input('site-id') siteId: string;
  // eslint-disable-next-line @angular-eslint/no-input-rename
  plantStartTime = '';
  operatingHours = '';
  plantStopTime = '';
  performanceRatioOneday = 0;
  latestIrradiance = 0;
  constructor(
    private plantService: PlantServiceService,
    private cd: ChangeDetectorRef
  ) {}
  ngOnChanges() {
    this.plantService.solarConfigSubject
      .asObservable()
      .subscribe((solarConfig) => {
        if (this.siteId !== undefined && solarConfig.processNameRids) {
          this.getData(solarConfig.processNameRids);
        }
      });
  }
  ngOnInit() {}

  ngOnDestroy() {
    // this.subscription.unsubscribe();
    // this.acSubscription.unsubscribe();
  }
  ngAfterViewInit() {
    this.cd.detectChanges();
    // this.plantService.solarConfigSubject.unsubscribe();
  }
  private getData(processNameRids: any) {
    const dateSelected = moment().format('YYYY-MM-DD');
    const process = Object.assign({}, processNameRids);
    const model = new PowerAndIrradianceTrendParametersModel(
      this.siteId,
      process,
      dateSelected
    );
    this.plantService.getPowerAndIrradianceTrend(model).subscribe((data) => {
      this.plantStartTime =
        data.PlantStartTime.length > 0 ? data.PlantStartTime[0].x : '';
      this.operatingHours =
        data.OperatingHours.length > 0 ? data.OperatingHours[0].x : '';
      this.plantStopTime =
        data.PlantStopTime.length > 0 ? data.PlantStopTime[0].x : '';
      // Calculate Plant Performance if its current day and we have latest energy and irradiance data
      if (data.LatestIrradiance != null && data.LatestIrradiance.length > 0) {
        this.latestIrradiance = data.LatestIrradiance[0].y;
        const cummulativeOneDayIrradiance =
          data.CummulativeOneDayIrradiance[0].y;
        const cummulativeOneDayPower = data.CummulativeOneDayPower[0].y;
        this.plantService
          .getSolarConfigurationInfo(this.siteId)
          .subscribe((config) => {
            //  this.solarConfig = <SolarConfigModel>data;
            //  this.totalInstalledCapacity = data.totalInstalledCapacity;
            //  this.processNameRids = data.processNameRids;
            // eslint-disable-next-line max-len
            this.performanceRatioOneday =
              (cummulativeOneDayPower /
                ((cummulativeOneDayIrradiance / 1000) *
                  config.totalInstalledCapacity)) *
              100;
          });
      }
    });
  }
}
